<template>
  <p class="text-gray-700 text-sm mb-2">You've chosen a {{product.name}}, {{flavour.name}}
     for {{product.amount | tightCurrency }}
    <template v-if="colour">
      in {{colour}}
    </template>
    <template v-if="group && group.message">
      <template v-if="message">
        with a message: "{{message}}"
      </template>
      <template v-else>
        with <strong>no message</strong>
      </template>
    </template>
  </p>
</template>

<script>
import { find } from 'lodash'
export default {
  props: ['sku', 'chosenFlavour','message','colour'],
  computed: {
    group() {
      return find(this.$root.$data.groups, {id: this.product.group})
    },
    product() {
      return find(this.$root.$data.products, {sku: this.sku })
    },
    flavour() {
      return find(this.$root.$data.flavours, {id: this.chosenFlavour })
    }
  },
}
</script>

<style>

</style>